import React from 'react';

const WizardIcon = ({
  size = 18,
  color = 'currentColor',
  strokeWidth = 1.5,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25.112 18.446"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      className="hover-stroke"
      d="M10.365 1.06l-6.216 6.2-3.088-3.1"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="hover-stroke"
      d="M10.365 11.493l-6.216 6.2-3.088-3.1"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      className="hover-stroke"
      x1="16.13"
      y1="4.162"
      x2="24.362"
      y2="4.162"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      className="hover-stroke"
      x1="16.13"
      y1="14.594"
      x2="24.362"
      y2="14.594"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WizardIcon;
